import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/SignUp.css";
import loginImg from "../../assets/loginImage.jpeg";
import Loader from "../../components/common/Loading";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import logo from "../../assets/Logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { EMAIL_REGEX, MOBILE_NUMBER_REGEX } from "../../constants/common";
import axios from "axios";

function SignUp() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    termsAndConditions: false,
  });

  const [submitted, setSubmitted] = useState(false); // State to track form submission
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State for showing password
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // State for showing password

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value; // Don't trim input values
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordConfirmVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitted(true);

    // Validation checks on client side
    if (formData.password !== formData.confirmPassword) {
      console.error("Passwords do not match");
      toast.error("Passwords do not match ");
      return;
    }

    if (!EMAIL_REGEX.test(formData.email)) {
      toast.error("Invalid email address");
      return;
    }

    const nameRegex = /^[A-Za-z ]+$/;
    if (!nameRegex.test(formData.firstName) || !nameRegex.test(formData.lastName)) {
      toast.error("First Name and Last Name should only contain alphabets and spaces");
      return;
    }

    const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      toast.error("Password must be at least 8 characters long and contain both letters and numbers");
      return;
    }

    const mobileRegex = /^[0-9]{8,15}$/;
    if (!mobileRegex.test(formData.mobile)) {
      toast.error("Invalid mobile number");
      return;
    }

    if (!formData.termsAndConditions) {
      console.error("Please accept the terms and conditions");
      return;
    }

    try {
      const resIsEmailExist = await axios.get(
        `https://yelospace.com/api/is-exist/user/${formData.email}`
      );
      if (resIsEmailExist.data.status === 200) {
        toast.error("Email already exists.");
        return;  
      }

      const resIsProviderEmailExist = await axios.get(
        `https://yelospace.com/api/is-exist/provider/${formData.email}`
      );
      if (resIsProviderEmailExist.data.status === 200) {
        toast.error("Email already exists for providers.");
        return;
      }

      const IsMobileExist = await axios.get(
        `https://yelospace.com/api/is-exist/user/${formData.mobile}`
      );

      if (IsMobileExist.data.status === 200) {
        toast.error("Mobile Number Already Exists.");
        return;  
      }
      setLoading(true); // Start loading
      // Exclude confirmPassword and termsAndConditions from formData
      const { confirmPassword, termsAndConditions, ...postData } = formData;

      const response = await fetch(
        "https://yelospace.com/api/send-otp/{email}",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postData),
        }
      );

      if (response.status === 200) {
        localStorage.setItem("formdata", JSON.stringify(postData));
        navigate("/verify-email");
      } else {
        console.error("Failed to sign up");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setLoading(false); // Finish loading
    }
  };

  return (
    <>
      <ToastContainer />
      {loading ? (
        <Loader className="d-flex justify-content-center align-items-center" />
      ) : (
        <div className="signup-container">
          <div className="left-panel">
            <img src={loginImg} alt="Left Panel Image" />
          </div>
          <div className="right">
          <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>
            <h3>Sign Up</h3>
            <form onSubmit={handleSubmit}>
              <div className="input-group-custums">
                <input
                  type="text"
                  id="firstname"
                  name="firstName"
                  placeholder="First Name *"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {submitted && !formData.firstName && (
                  <span className="error-signup">First Name is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name *"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {submitted && !formData.lastName && (
                  <span className="error-signup">Last Name is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                />
                {submitted && !formData.email && (
                  <span className="error-signup">Email is required</span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  placeholder="Mobile Number *"
                  value={formData.mobile}
                  onChange={handleChange}
                />
                {submitted && !formData.mobile && (
                  <span className="error-signup">
                    Mobile Number is required
                  </span>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password *"
                  value={formData.password}
                  onChange={handleChange}
                />
                <span
                  className="password-toggle-btn"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  ) : (
                    <FontAwesomeIcon icon={faEye} />
                  )}
                </span>
              </div>
              <div>
                {submitted && !formData.password && (
                  <div className="error-signup">Password is required</div>
                )}
              </div>
              <div className="input-group-custums">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm Password *"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
                <span
                  className="password-toggle-btn"
                  onClick={togglePasswordConfirmVisibility}
                >
                  {showConfirmPassword ? (
                    <FontAwesomeIcon icon={faEyeSlash} />
                  ) : (
                    <FontAwesomeIcon icon={faEye} />
                  )}
                </span>
              </div>
              <div>
                {submitted && !formData.confirmPassword && (
                  <div className="error-signup">
                    Confirm Password is required
                  </div>
                )}
              </div>
              <div className="checkbox-group-custum">
                <input
                  type="checkbox"
                  id="termsAndConditions"
                  name="termsAndConditions"
                  checked={formData.termsAndConditions}
                  onChange={handleChange}
                />
                <label htmlFor="termsAndConditions">
                  I accept the{" "}
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms and Conditions
                  </a>{" "}
                  and{" "}
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </label>
              </div>
              <div>
                {submitted && !formData.termsAndConditions && (
                  <p className="error-signup">
                    Please accept the terms and conditions
                  </p>
                )}
              </div>

              <div className="d-flex justify-content-center w-100 mt-2">
                <button type="submit" className="submit-btn">
                  Sign Up
                </button>
              </div>
              <div className="d-flex justify-content-center w-100 mt-4">
                <div className="continue">
                  <Link to="/" className="border py-3 px-3" style={{fontWeight:'bold'}}>
                    Continue As Guest
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default SignUp;
